import React from 'react';
import styles from './OverviewCard.module.scss';

/**
 * Lovable-design-aligned card chrome for the Overview redesign (NEA-5635).
 * Matches the design's 12px radius and double-stack shadow. Use for ALL
 * cards on the new Overview page; do not use the legacy InsightCardContainer.
 */
export const OverviewCard = ({ children, className = '' }) => <div className={`${styles.card} ${className}`}>{children}</div>;
